// extracted by mini-css-extract-plugin
module.exports = {"table":"RolesTable_table__1xhON","button":"RolesTable_button__3bZhF"};